export default "__VITE_ASSET__7ce5485c__"